module.exports = __webpack_public_path__ + "static/Statice-4a72d5fd6f792943d912b9beadca387a.jpg";